import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { filterOptions, properties3 } from "../../../data/properties";
import { BaseURL } from "../../../APIs/APIUrls";
import { GetAllPropertyforWeb, GetAllPropertyTypesforWeb } from "../../../APIs/APIHelperforWeb.js";
import { checkWhatsAppChatOptionById } from "../../../APIs/VendorLoginAPI";
import { useSnackbar } from "notistack";
import Enquiry from "../../modals/Enquiry";



export default function Properties({ objFeaturedProperties, propertyTypes }) {

  const [selectedOption, setSelectedOption] = useState("0");
  const [filtered, setFiltered] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [PorpertyTypes, setPropertyTypes] = useState(propertyTypes);
  const [FeaturedProperties, setFeaturedProperties] = useState(objFeaturedProperties);
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [FlagType, setFlagType] = useState("");
  const [PropertyId, setPropertyId] = useState(null);




  const handleOpenEnquiry = (flagType, PropertyId) => {
    setFlagType(flagType);
    setIsEnquiryOpen(true);
    setPropertyId(PropertyId);
  }

  const handleCloseEnquiry = () => setIsEnquiryOpen(false);

  const handleEnquirySubmit = () => {
    setIsEnquiryOpen(false);

  };

  const { enqueueSnackbar } = useSnackbar();

  const handleWhatsAppClick = async (property) => {
    try {
      const vendorId = property?.VendorId || property?.vendorid || property?.vendorId || property?.Vendor || 0;
      const res = await checkWhatsAppChatOptionById(vendorId);
      debugger;
      if (!res || !res.success) {
        handleOpenEnquiry('whatsapp', property.PropertyId);
        return;
      }
      const info = res.data || {};
      const isOn = info.IsWhatsAppChat === true;
      const mobile = (info.Mobile || "").toString().trim();
      if (isOn) {
        if (mobile) {
          const cleaned = mobile.replace(/[^0-9+]/g, "");
          const text = encodeURIComponent("Hi, I am interested in your property\n " + property.PropertyGeneratedId + " | " + property.PropertyTitle + "\n Property Link: " + window.location.href + `property-details/${property.AutoGeneratedURL}`);
          const url = `https://api.whatsapp.com/send?phone=${cleaned}&text=${text}`;
          window.open(url, '_blank');
        } else {
          handleOpenEnquiry('whatsapp', property.PropertyId);
        }
      } else {
        handleOpenEnquiry('whatsapp', property.PropertyId);
      }
    } catch (error) {
      enqueueSnackbar && enqueueSnackbar('Unable to start WhatsApp chat', { variant: 'error' });
      handleOpenEnquiry('whatsapp', property.PropertyId);
    }
  }



  useEffect(() => {
    if (selectedOption == "0") {
      setFiltered(FeaturedProperties);
    } else {
      let filteredProperties = FeaturedProperties.filter((el) => el.PropertyTypeId == selectedOption);
      setFiltered(filteredProperties);
    }
    setShowAll(false);
  }, [selectedOption, FeaturedProperties]);

  useEffect(() => {
    const initializeData = async () => {
      if (objFeaturedProperties && objFeaturedProperties.length > 0) {
        setFiltered(objFeaturedProperties);
        setFeaturedProperties(objFeaturedProperties);
      }
      else {
        const featuredProperties = JSON.parse(localStorage.getItem('AllFeaturedPropertiesforWeb')) || [];
        if (featuredProperties.length > 0) {
          setFiltered(featuredProperties);
          setFeaturedProperties(featuredProperties);
        }
        else {
          await GetAllPropertyforWeb();
          const featuredProperties = JSON.parse(localStorage.getItem('AllFeaturedPropertiesforWeb')) || [];
          if (featuredProperties.length > 0) {
            setFiltered(featuredProperties);
            setFeaturedProperties(featuredProperties);
          }
        }
      }



      if (propertyTypes && propertyTypes.length > 0) {
        setPropertyTypes(propertyTypes);
      }
      else {
        const featuredPropertyTypes = JSON.parse(localStorage.getItem('AllPropertyTypesforWeb')) || [];
        if (featuredPropertyTypes.length > 0) {
          setPropertyTypes(featuredPropertyTypes);
        }
        else {
          await GetAllPropertyTypesforWeb();
          const featuredPropertyTypes = JSON.parse(localStorage.getItem('AllPropertyTypesforWeb')) || [];
          if (featuredPropertyTypes.length > 0) {
            setPropertyTypes(featuredPropertyTypes);
          }
        }
        setSelectedOption(featuredPropertyTypes.length > 0 ? featuredPropertyTypes[0].TypeId : "0");
      }
    };

    initializeData();
  }, []);


  const returnCardImage = (propertyid, PropertyImages) => {
    if (!PropertyImages || !PropertyImages.length) {
      return "https://via.placeholder.com/615x405?text=No+Image";
    }
    const cardImage = PropertyImages.filter(x => x.IsCard === true && x.PropertyId == propertyid)?.[0]?.ImageURL;
    return cardImage ? BaseURL + cardImage : "https://via.placeholder.com/615x405?text=No+Image";
  }




  return (
    <section className="flat-section flat-recommended pt-0">
      <div className="container">
        <div className="box-title text-center wow fadeInUp">
          <div className="text-subtitle text-primary">Featured Properties</div>
          <h3 className="title mt-4">
            Discover AskMeReality Finest Properties
          </h3>
        </div>
        <div
          className="flat-tab-recommended flat-animate-tab wow fadeInUp"
          data-wow-delay=".2s"
        >
          <ul className="nav-tab-recommended justify-content-md-center">
            {
              PorpertyTypes.map((option, index) => (
                <li
                  onClick={() => setSelectedOption(option.TypeId)}
                  key={index}
                  className="nav-tab-item"
                >
                  <a
                    className={`nav-link-item ${option.TypeId === selectedOption ? "active" : ""
                      }`}
                  >
                    {option.TypeName}
                  </a>
                </li>
              ))}
          </ul>
          <div className="tab-content">
            <div
              className="tab-pane active show"
              id="apartment"
              role="tabpanel"
            >
              <div className="row">
                {(showAll ? filtered : filtered.slice(0, 6)).map((property, index) => (
                  <div key={index} className="col-xl-4 col-lg-6 col-md-6">
                    <div className="homelengo-box">
                      <div className="archive-top">
                        <Link
                          to={`/property-details/${property.AutoGeneratedURL}`}
                          className="images-group"
                        >
                          <div className="images-style">
                            <img
                              className="lazyload"
                              data-src={returnCardImage(property.PropertyId, property._lstPropertyImages)}
                              alt={property?.PropertyTitle}
                              src={returnCardImage(property.PropertyId, property._lstPropertyImages)}
                              width={615}
                              height={405}
                              loading="lazy"
                            />
                          </div>
                          <div className="top">
                            <ul className="d-flex gap-6">
                              {
                                property?.IsFeatured && (
                                  <li className="flag-tag primary">Featured</li>
                                )
                              }

                              <li className="flag-tag style-1">For {property?.PropertyFor}</li>
                              <li className="flag-tag style-1">{property?.PropertyTypeName}</li>
                            </ul>
                          </div>
                          <div className="bottom">
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7Z"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7Z"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <span className="text-line-clamp-1">
                              {property.CityName} - {property.StateName}
                            </span>
                          </div>
                        </Link>
                      </div>
                      <div className="archive-bottom">
                        <div className="content-top">
                          <h6 className="text-capitalize">
                            <Link
                              to={`/property-details/${property.AutoGeneratedURL}`}
                              className="link"
                            >
                              {property.PropertyGeneratedId} &nbsp;&nbsp;|&nbsp;&nbsp; {property.PropertyTitle}
                            </Link>
                          </h6>
                          <h6 style={{ fontSize: "13px" }}>
                            {property?.PropertyTypeName}
                          </h6>
                          <ul className="meta-list">

                            {
                              property.NoofRoom && (
                                <>
                                  <li className="item">
                                    <i className="icon icon-bed" />
                                    <span className="text-variant-1">Beds:</span>
                                    <span className="fw-6">{property.NoofRoom}</span>
                                  </li>
                                </>
                              )
                            }
                            {
                              property.NoofWashroom && (
                                <li className="item">
                                  <i className="icon icon-bath" />
                                  <span className="text-variant-1">Baths:</span>
                                  <span className="fw-6">{property.NoofWashroom}</span>
                                </li>

                              )
                            }
                            {
                              property.PropertyFor === "Sell" && (
                                <li className="item">
                                  <i className="icon icon-sqft" />
                                  <span className="fw-6">Land Area: {property.LandSize}</span>
                                  <span className="text-variant-1">{property.LandSizeUnit}</span>

                                </li>
                              )
                            }
                            {
                              (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.CarpetArea ?
                                (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.CarpetArea && (
                                  <li className="item">
                                    <i className="icon icon-sqft" />

                                    <span className="fw-6">Carpet Area: {property.CarpetArea}</span>
                                    <span className="text-variant-1">{property.CarpetAreaUnitSize}</span>
                                  </li>
                                ) :
                                (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.BuiltUpArea ?
                                  (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.BuiltUpArea && (
                                    <li className="item">
                                      <i className="icon icon-sqft" />
                                      <span className="fw-6">Constructed Area: {property.BuiltUpArea}</span>
                                      <span className="text-variant-1">{property.BuiltUpAreaUnitSize}</span>
                                    </li>
                                  ) :
                                  (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.SuperArea ?
                                    (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.SuperArea && (
                                      <li className="item">
                                        <i className="icon icon-sqft" />
                                        <span className="fw-6">Constructed Area: {property.SuperArea}</span>
                                        <span className="text-variant-1">{property.SuperAreaUnitSize}</span>
                                      </li>
                                    ) : null
                            }

                          </ul>
                        </div>
                        <div className="content-bottom">
                          <div className="d-flex gap-8 align-items-center">
                            {/* <div className="avatar avt-40 round">
                              <img
                                alt="avt"
                                src={property.avatar}
                                width={34}
                                height={34}
                              />
                            </div> */}
                            <span>{property.BuildingTypeName} &nbsp;&nbsp;|&nbsp;&nbsp; {property.FurnishingStatus}</span>
                          </div>
                          <h6 className="price" style={{ fontSize: "16px", fontWeight: "500" }}>
                            {
                              property.PropertyFor == "Rent" || property.PropertyFor == "PG"
                                ? `₹ ${new Intl.NumberFormat('en-IN').format(property.RentPerMonth)} /Month`
                                :
                                property.PropertyFor == "Sell" ?
                                  `₹ ${new Intl.NumberFormat('en-IN').format(property.ExpectedPrice)} /${property.ExpectedPricePerUnit}`
                                  : null
                            }

                          </h6>
                        </div>
                        <div className="property-contact-actions">
                          <a onClick={() => handleOpenEnquiry('call', property.PropertyId)} className="property-contact-action property-contact-action-call" aria-label="Call AskMeReality now">
                            <span className="icon icon-phone2" />
                            <span>Call Now</span>
                          </a>
                          <a onClick={() => handleWhatsAppClick(property)} className="property-contact-action property-contact-action-whatsapp" aria-label="Chat with AskMeReality on WhatsApp">
                            <span className="icon icon-whatsapp" aria-hidden="true" />
                            <span>WhatsApp</span>
                          </a>
                          <button type="button" className="property-contact-action property-contact-action-enquiry" onClick={() => handleOpenEnquiry('enquiry', property.PropertyId)}>
                            <span className="icon icon-send" />
                            <span>Enquiry</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {filtered.length > 6 ? (
                <div className="text-center">
                  <a
                    href="#"
                    className="tf-btn btn-view primary size-1 hover-btn-view"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowAll((prev) => !prev);
                    }}
                  >
                    {showAll ? "Show Less" : "View All Properties"}
                    <span className="icon icon-arrow-right2" />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <Enquiry isOpen={isEnquiryOpen} onClose={handleCloseEnquiry} onSubmit={handleEnquirySubmit} flagType={FlagType} propertyId={PropertyId} />
    </section>
  );
}
